<template>
  <li class="d-flex align-items-center border-bottom">
    <div class="shohin_group d-flex align-items-center my-3">
      <p>{{ no }}</p>
      <img :src="thumb" @error="noImage()" :alt="name" class="mx-4" />
      <p>{{ name }}</p>
    </div>
    <div class="shohin_quantity text-center my-3">
      <select class="w-auto px-3 select_no" :value="itemCount" v-model="count">
        <option v-for="n in optionCount" :key="n" :value="n">
          {{ n }}
        </option>
      </select>
      個
      <a href="javascript:void(0)" v-on:click="deleteItem" class="btn ml-3">削除</a>
    </div>
    <div class="shohin_price my-3">
      <p class="text-right">{{ price }}円</p>
    </div>
  </li>
</template>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
let request = new Request();

export default {
  props: ["no", "itemNo", "optionCount", "itemCount", "name", "type", "code", "price"],
  data() {
    return {
      count: this.itemCount,
      thumb: process.env.VUE_APP_CONTENTS_PRODUCT_HOME + this.itemNo + "/thumb.jpg",
    };
  },
  mounted() {
    console.log(this.itemCount);
  },
  watch: {
    itemCount: function(newVal){
      this.count = newVal;
    },
    count: function (newVal, oldVal) {
      let postParams = [this.type, this.code, newVal, 1];
      let requestParams = request.createParams(
        "webMdlCart",
        "putCart",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          Message.success().fire({
            title: "カート内の商品数量を変更しました",
            text: "商品名:" + this.name + " 個数:" + oldVal + " -> " + newVal,
          });

          // 親コンポーネントのloadCartをemitする
          this.$emit("loadCart");
        });
    },
  },
  methods: {
    noImage() {
      // 画像の読み込みに失敗すればnoimage
      this.thumb = process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "/nothumb.jpg";
    },
    deleteItem() {
      // 削除するキーを取得
      let postParams = [this.type, this.code, this.count];
      let requestParams = request.createParams(
        "webMdlCart",
        "delCart",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          Message.success().fire({
            title: "カートから商品を削除しました",
            text: "商品名:" + this.name,
          });
          // 親コンポーネントのloadCartをemitする
          this.$emit("loadCart");
        });
    },
  },
};
</script>